import React, { Component, createRef, Fragment } from "react";
import { Grid, Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import EventList from "../EventList/EventList";
import { getEventsForDashboard } from "../eventActions";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import EventActivity from "../EventActivity/EventActivity";

const mapState = state => ({
  events: state.events,
  loading: state.async.loading,
  activities: state.firestore.ordered.activity
});

const actions = {
  getEventsForDashboard
};

class EventDashboard extends Component {
  contextRef = createRef();

  state = {
    moreEvents: false,
    loadingInitial: true,
    loadedEvents: []
  };

  async componentDidMount() {
    let next = await this.props.getEventsForDashboard();

    if (next && next.docs && next.docs.length > 1) {
      this.setState({
        moreEvents: true,
        loadingInitial: false
      });
    }
  }

  componentDidUpdate = prevProps => {
    if (this.props.events !== prevProps.events) {
      this.setState({
        loadedEvents: [...this.state.loadedEvents, ...this.props.events]
      });
    }
  };

  getNextEvents = async () => {
    const { events } = this.props;
    let lastEvent = events && events[events.length - 1];
    let next = await this.props.getEventsForDashboard(lastEvent);
    if (next && next.docs && next.docs.length <= 1) {
      this.setState({
        moreEvents: false
      });
    }
  };

  render() {
    const { loading } = this.props;
    const { moreEvents, loadedEvents } = this.state;

    if (this.state.loadingInitial) return <LoadingComponent />;

    return (
      <Fragment>
        <Grid>
          <Grid.Column mobile={16} tablet={10} computer={10}>
            <div ref={this.contextRef}>
              <EventList
                loading={loading}
                events={loadedEvents}
                moreEvents={moreEvents}
                getNextEvents={this.getNextEvents}
              />
            </div>
          </Grid.Column>

          <Grid.Column width={6} only="tablet computer">
            <EventActivity contextRef={this.contextRef} />
          </Grid.Column>
          <Grid.Column
            width={10}
            textAlign="center"
            className="center-infinite-scroll-loading"
          >
            <Loader active={loading} />
          </Grid.Column>
        </Grid>
      </Fragment>
    );
  }
}

export default connect(
  mapState,
  actions
)(EventDashboard);
